/**
 * Uplifted from `utils/sideNavConstants.ts` — the file exists in BOTH apps.
 *
 * **All 15 of web's exports are byte-identical to mobile's** (measured by symbol/body diff
 * after whitespace normalisation: 0 web-only, 0 differing bodies), so they are all here.
 * Mobile declares THREE more — the `ITEM_LABEL_SETTINGS_*` trio — which live in
 * `index.native.ts`.
 *
 * These are settings-navigation ids/titles/descriptions, read by name. Pure data — no imports,
 * nothing read at load time.
 *
 * ⚠️ `PRINER_NAV_DESC` is misspelled in both apps (one `T`). Kept verbatim: renaming it is a
 * consumer change, not an uplift.
 */
export const PRINTER_NAV_TITLE = "Printer Setup";
export const PRINER_NAV_DESC = "Add and configure printers for this branch";
export const PRINTER_NAV_ID = "printer01";

export const POS_NAV_ID = "pos00";
export const POS_NAV_TITLE = "POS Preferences";
export const POS_NAV_DESC = "Specify Sale Preferences";

export const KOT_NAV_ID = "KOT02";
export const KOT_NAV_TITLE = "KOT settings";
export const KOT_NAV_DESC = "Add and configure printers for this branch";

export const BILL_NAV_ID = "bill03";
export const BILL_NAV_TITLE = "Bill Template";
export const BILL_NAV_DESC = "Add and configure printers for this branch";

export const POS_SETTING = "POS Settings";

export const SETTING_TITLE = "Settings";

export const CASH_REGISTER_NAV_ID = "CR02";
